// I18n
export const LOCALE_DEFAULT = 'en';
export const LOCALE_SUPPORT = [
  'en',
  'vi',
];

// timezone
export const TIMEZONE_DEFAULT = 'Asia/Phnom_Penh';